import(/* webpackMode: "eager", webpackExports: ["AppShell"] */ "/vercel/path0/front_end/components/app-shell.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/vercel/path0/front_end/components/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SafeHydrationProvider"] */ "/vercel/path0/front_end/components/safe-hydration.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/front_end/node_modules/.pnpm/next@15.2.4_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/front_end/styles/globals.css");
